const regex = /^[+]?(?:[0-9]*?){6,14}[0-9]$/;

export default value => {
  return value.match(regex) !== null;
};
